'use strict';
const angular = require('angular');

export class AutocompleteRedirectComponent {
  /*@ngInject*/
  constructor($location, SettingsService) {
    this.$location = $location;
    this.SettingsService = SettingsService;
  }

  $onInit() {
    if (!this.minlength)
      this.minlength = 3;

    this.SettingsService.getPublicByName({name: this.settings}, settings => {
      this.data = settings.data;
      this.choices = Object.keys(this.data);
    });

  }

  onChange() {
    let url = this.data[this.selected];

    if (url) {
      this.$location.url(url);
    }
  }

}

export default angular.module('conduuApp.autocompleteRedirect', [])
  .component('autocompleteRedirect', {
    template: require('./autocomplete-redirect.html'),
    bindings: {
      minlength: '@',
      settings: '@'
      /*choices: '=',
      enteredtext: '=',
      minlength: '=',
      selected: '='*/
    },
    controller: AutocompleteRedirectComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/autocomplete-redirect/autocomplete-redirect.component.js